import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Multiselect from 'vue-multiselect';
import { getMasterDataSchemaApi, getMasterDataSitesApi, linkPlantApi, unlinkPlantApi } from '@/api/selfAnalysis';
import TopologyNodesPanel from '@/components/selfAnalysis/TopologyNodesPanel.vue';
import VoltageConfigsPanel from '@/components/selfAnalysis/VoltageConfigsPanel.vue';
import InverterMasterPanel from '@/components/selfAnalysis/InverterMasterPanel.vue';
import MpptStringMapPanel from '@/components/selfAnalysis/MpptStringMapPanel.vue';
import StringDesignPanel from '@/components/selfAnalysis/StringDesignPanel.vue';
import StatusCodesPanel from '@/components/selfAnalysis/StatusCodesPanel.vue';

/**
 * 自主分析：MPPT 電壓異常診斷要用的案場主檔維護（見 ADR-0011）。
 *
 * 六個分頁對到 Cloud SQL `trend_analytics` 的六張表（02～07）。07 由品牌庫 `inverter_status_codes` 依 04 的品牌帶入。這個庫跟 `postgres` 庫是分開的，
 * 做不到跨庫 JOIN，所以案場清單是後端另外跟 Cosmos 要的（`/api/trendanalytics/sites`），
 * **不是** Cloud SQL 那張 factories_info —— 那張只有 8 列而且沒有 f001。
 *
 * 欄位定義一律跟後端要（`/api/trendanalytics/schema`），前端不抄一份，免得跟 DDL 走鐘。
 */
export default {
  name: 'SelfAnalysis',
  components: {
    Multiselect: Multiselect,
    TopologyNodesPanel: TopologyNodesPanel,
    VoltageConfigsPanel: VoltageConfigsPanel,
    InverterMasterPanel: InverterMasterPanel,
    MpptStringMapPanel: MpptStringMapPanel,
    StringDesignPanel: StringDesignPanel,
    StatusCodesPanel: StatusCodesPanel
  },
  data: function data() {
    return {
      schema: null,
      siteList: [],
      siteCode: '',
      tabIndex: 0,
      mergeTarget: '',
      busy: false,
      error: ''
    };
  },
  computed: {
    /** 已經有主檔資料的排前面，後面標幾列，不用逐一點開才知道哪些建過 */siteOptions: function siteOptions() {
      var label = function label(s) {
        return "".concat(s.code, " \u2014 ").concat(s.name) + (s.rows ? "\uFF08\u5DF2\u6709 ".concat(s.rows, " \u5217\uFF09") : '');
      };
      var done = this.siteList.filter(function (s) {
        return s.rows;
      });
      var rest = this.siteList.filter(function (s) {
        return !s.rows && !s.standalone;
      });
      var external = this.siteList.filter(function (s) {
        return !s.rows && s.standalone;
      });
      var opt = function opt(s) {
        return {
          value: s.code,
          text: label(s)
        };
      };
      if (!this.siteList.length) return [];
      return [].concat(_toConsumableArray(done.length ? [{
        label: '已建主檔',
        options: done.map(opt)
      }] : []), [{
        label: '其他案場',
        options: rest.map(opt)
      }], _toConsumableArray(external.length ? [{
        label: '其他監控來源（未對應到案場）',
        options: external.map(opt)
      }] : []));
    },
    /** multiselect 要的是選項物件，頁面其他地方用的是代號字串，在這裡轉 */
    selectedSite: {
      get: function get() {
        var _this = this;
        return this.siteOptions.flatMap(function (g) {
          return g.options;
        }).find(function (o) {
          return o.value === _this.siteCode;
        }) || null;
      },
      set: function set(o) {
        this.siteCode = (o === null || o === void 0 ? void 0 : o.value) || '';
      }
    },
    selectedMergeTarget: {
      get: function get() {
        var _this2 = this;
        return this.mergeOptions.find(function (o) {
          return o.value === _this2.mergeTarget;
        }) || null;
      },
      set: function set(o) {
        this.mergeTarget = (o === null || o === void 0 ? void 0 : o.value) || '';
      }
    },
    site: function site() {
      var _this3 = this;
      return this.siteList.find(function (s) {
        return s.code === _this3.siteCode;
      });
    },
    /** 只能併進 factories_info 的案場，不能併進另一座外部電廠 */mergeOptions: function mergeOptions() {
      return this.siteList.filter(function (s) {
        return !s.standalone && s.name !== '（不在案場清單）';
      }).map(function (s) {
        return {
          value: s.code,
          text: "".concat(s.code, " \u2014 ").concat(s.name)
        };
      });
    },
    withData: function withData() {
      return this.siteList.filter(function (s) {
        return s.rows;
      });
    }
  },
  watch: {
    siteCode: function siteCode() {
      this.mergeTarget = '';
    }
  },
  created: function created() {
    var _this4 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this4$withData$, _yield$Promise$all, _yield$Promise$all2, schemaRes, sitesRes;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return Promise.all([getMasterDataSchemaApi(), getMasterDataSitesApi()]);
            case 3:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              schemaRes = _yield$Promise$all2[0];
              sitesRes = _yield$Promise$all2[1];
              _this4.schema = schemaRes.data;
              _this4.siteList = sitesRes.data || [];
              // 已經建過主檔的排第一個，直接開，省一次點選
              _this4.siteCode = ((_this4$withData$ = _this4.withData[0]) === null || _this4$withData$ === void 0 ? void 0 : _this4$withData$.code) || '';
              _context.next = 15;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](0);
              _this4.error = (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.msg) || (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message) || '連不到主檔資料庫（trend_analytics）';
            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 12]]);
    }))();
  },
  methods: {
    /** 表格存過東西之後重抓，讓下拉的「已有幾列」跟著動。失敗就沿用舊的，不擋操作 */loadSites: function loadSites() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return getMasterDataSitesApi();
              case 3:
                res = _context2.sent;
                _this5.siteList = res.data || _this5.siteList;
                _context2.next = 10;
                break;
              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                console.log('reload sites failed', _context2.t0);
              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }))();
    },
    link: function link() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this6$site$plants, p, target;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this6$site$plants = _slicedToArray(_this6.site.plants, 1), p = _this6$site$plants[0];
                target = _this6.mergeTarget;
                _this6.busy = true;
                _this6.error = '';
                _context3.prev = 4;
                _context3.next = 7;
                return linkPlantApi(p.provider, p.plant_no, target);
              case 7:
                _context3.next = 9;
                return _this6.loadSites();
              case 9:
                _this6.siteCode = target;
                _context3.next = 15;
                break;
              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](4);
                _this6.error = (_context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.msg) || (_context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.message) || '併入失敗';
              case 15:
                _context3.prev = 15;
                _this6.busy = false;
                return _context3.finish(15);
              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[4, 12, 15, 18]]);
      }))();
    },
    unlink: function unlink(p) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this7.busy = true;
                _this7.error = '';
                _context4.prev = 2;
                _context4.next = 5;
                return unlinkPlantApi(p.provider, p.plant_no);
              case 5:
                _context4.next = 7;
                return _this7.loadSites();
              case 7:
                _context4.next = 12;
                break;
              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](2);
                _this7.error = (_context4.t0 === null || _context4.t0 === void 0 ? void 0 : _context4.t0.msg) || (_context4.t0 === null || _context4.t0 === void 0 ? void 0 : _context4.t0.message) || '拆開失敗';
              case 12:
                _context4.prev = 12;
                _this7.busy = false;
                return _context4.finish(12);
              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 9, 12, 15]]);
      }))();
    }
  }
};